module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKIEBSD.70ed54fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKIEBSD.png
// module id = 64
// module chunks = 0